import { createReducer } from "redux-create-reducer";
import { ACCTS_ACTIONS } from "./acctsActions";
import { MISC_ACCTS_ACTIONS, RESET_MESSAGES } from "../misc/miscActions";
import { AUTH_ACTIONS } from "../auth/authActions";
import { PAYMENT_ACTIONS } from "../payment/paymentActions";
import { REHYDRATE } from "redux-persist/constants";
import callbackReducer, { INITIAL_STATE as CALLBACK_INITIAL_STATE } from "./callbackReducer";
import { LOCATION_CHANGE } from "react-router-redux";
const VERSION = 6;
const INITIAL_STATE = {
    version: VERSION,
    isLoading: false,
    isSuccess: null,
    emailOptOut: {
        isLoading: false,
        isSuccess: null,
        error: null,
        dataIsLoading: false,
        dataIsSuccess: null,
        dataError: null
    },
    data: null,
    error: null,
    accountToEdit: null,
    fieldErrors: [],
    callback: CALLBACK_INITIAL_STATE,
    probateCase: {
        isSaving: false,
        error: null,
        fieldErrors: {
            globalError: null,
            backendErrors: {}
        }
    },
    autoAddedPayable: false,
    relationship: {
        isLoading: false,
        fieldErrors: []
    }
};
export const AUTO_ADDED_PAYABLE_MESSAGE_DOMAIN = "autoAddedPayable-bb7b7054";
const reducer = createReducer(INITIAL_STATE, {
    [REHYDRATE](state, action) {
        const { accts } = action.payload;
        if (accts && accts.version === VERSION) {
            return {
                ...state,
                accountToEdit: accts.accountToEdit
            };
        }
        return { ...state };
    },
    /* --- Account data load --- */
    [ACCTS_ACTIONS.ACCTS_LOAD_STARTED](state, _action) {
        return {
            ...state,
            isLoading: true,
            error: null,
            fieldErrors: []
        };
    },
    [ACCTS_ACTIONS.ACCTS_LOAD_FAILED](state, action) {
        return {
            ...state,
            isLoading: false,
            error: action.payload
        };
    },
    [ACCTS_ACTIONS.ACCTS_LOAD_SUCCEEDED_FALSE](state, action) {
        return {
            ...state,
            isLoading: false,
            isSuccess: false,
            fieldErrors: action.payload
        };
    },
    [ACCTS_ACTIONS.ACCTS_LOAD_SUCCEEDED_TRUE](state, action) {
        return {
            ...state,
            isLoading: false,
            isSuccess: true,
            data: action.payload.accts,
            autoAddedPayable: state.autoAddedPayable || action.payload.autoAddedPayable
        };
    },
    [ACCTS_ACTIONS.LOAD_EMAILOPTOUTS_STARTED](state, _action) {
        return {
            ...state,
            emailOptOut: {
                ...state.emailOptOut,
                dataIsLoading: true,
                dataIsSuccess: null,
                dataError: null
            }
        };
    },
    [ACCTS_ACTIONS.LOAD_EMAILOPTOUTS_SUCCEEDED](state) {
        return {
            ...state,
            emailOptOut: {
                ...state.emailOptOut,
                dataIsLoading: false,
                dataIsSuccess: true,
                dataError: null
            }
        };
    },
    [ACCTS_ACTIONS.LOAD_EMAILOPTOUTS_FAILED](state, { payload }) {
        return {
            ...state,
            emailOptOut: {
                ...state.emailOptOut,
                dataIsLoading: false,
                dataIsSuccess: false,
                dataError: payload
            }
        };
    },
    /* --- Email opt out actions --- */
    [ACCTS_ACTIONS.EMAIL_OPT_OUT_STARTED](state, _action) {
        return {
            ...state,
            emailOptOut: {
                ...state.emailOptOut,
                isLoading: true,
                error: null,
                fieldErrors: []
            }
        };
    },
    [ACCTS_ACTIONS.EMAIL_OPT_OUT_FAILED](state, action) {
        return {
            ...state,
            emailOptOut: {
                ...state.emailOptOut,
                isLoading: false,
                error: action.payload
            }
        };
    },
    [ACCTS_ACTIONS.EMAIL_OPT_OUT_SUCCEEDED_FALSE](state, action) {
        return {
            ...state,
            emailOptOut: {
                ...state.emailOptOut,
                isLoading: false,
                isSuccess: false,
                error: action.payload
            }
        };
    },
    [ACCTS_ACTIONS.EMAIL_OPT_OUT_SUCCEEDED_TRUE](state) {
        return {
            ...state,
            emailOptOut: {
                ...state.emailOptOut,
                isLoading: false,
                isSuccess: true,
            }
        };
    },
    /* --- Relationship Update --- */
    [ACCTS_ACTIONS.SET_ACCOUNT_TO_EDIT](state, action) {
        return {
            ...state,
            accountToEdit: action.payload
        };
    },
    [ACCTS_ACTIONS.UPDATE_RELATIONSHIP_STARTED](state, _action) {
        return {
            ...state,
            relationship: {
                ...state.relationship,
                isLoading: true,
                error: null,
                fieldErrors: []
            }
        };
    },
    [ACCTS_ACTIONS.UPDATE_RELATIONSHIP_FAILED](state, action) {
        return {
            ...state,
            relationship: {
                ...state.relationship,
                isLoading: false,
            },
            error: action.payload
        };
    },
    [ACCTS_ACTIONS.UPDATE_RELATIONSHIP_SUCCEEDED_FALSE](state, action) {
        return {
            ...state,
            relationship: {
                ...state.relationship,
                isLoading: false,
                fieldErrors: action.payload
            }
        };
    },
    [ACCTS_ACTIONS.UPDATE_RELATIONSHIP_SUCCEEDED_TRUE](state, action) {
        return {
            ...state,
            relationship: {
                ...state.relationship,
                isLoading: false
            },
            data: action.payload.accts,
            autoAddedPayable: state.autoAddedPayable || action.payload.autoAddedPayable
        };
    },
    /* --- Reset Status Messages --- */
    [MISC_ACCTS_ACTIONS.RESET_MESSAGES](state, _action) {
        return {
            ...state,
            error: null,
            isSuccess: null,
            isLoading: false,
            fieldErrors: []
        };
    },
    [AUTH_ACTIONS.LOGOUT](_state, _action) {
        return INITIAL_STATE;
    },
    [PAYMENT_ACTIONS.PAYMENT_CREATE_SUCCEEDED_TRUE](state, action) {
        const { data } = action.payload;
        if (data.type === "NotAvailable") {
            const newData = state.data.map(acct => {
                if (acct.id === data.accountId) {
                    return {
                        ...acct,
                        paymentAllowedAt: data.paymentAvailableAt
                    };
                }
                return acct;
            });
            return { ...state, data: newData };
        }
        return state;
    },
    [PAYMENT_ACTIONS.CANCEL_PAYMENT_SUCCEEDED](state, { payload }) {
        return {
            ...state,
            data: payload.accts
        };
    },
    [PAYMENT_ACTIONS.PAYMENT_CREATE_SUCCEEDED_TRUE](state, { payload }) {
        if (payload.success && payload.data.accounts != null) {
            return {
                ...state,
                data: payload.data.accounts
            };
        }
        return state;
    },
    [ACCTS_ACTIONS.ADD_PROBATE_CASE_STARTED](state, _action) {
        return {
            ...state,
            probateCase: {
                ...state.probateCase,
                isSaving: true,
                error: null,
                fieldErrors: INITIAL_STATE.probateCase.fieldErrors
            }
        };
    },
    [ACCTS_ACTIONS.ADD_PROBATE_CASE_FAILED](state, { payload }) {
        return {
            ...state,
            probateCase: {
                ...state.probateCase,
                isSaving: false,
                error: payload
            }
        };
    },
    [ACCTS_ACTIONS.ADD_PROBATE_CASE_SUCCEEDED](state, { payload }) {
        let { data } = state;
        let { fieldErrors } = INITIAL_STATE.probateCase;
        if (payload.success) {
            data = payload.data;
        }
        else {
            fieldErrors = payload.errors;
        }
        return {
            ...state,
            data,
            probateCase: {
                ...state.probateCase,
                isSaving: false,
                error: null,
                fieldErrors
            }
        };
    },
    [LOCATION_CHANGE](state, { payload }) {
        if (payload.pathname.toLowerCase().startsWith("/secured/probateCase/")) {
            return {
                ...state,
                probateCase: INITIAL_STATE.probateCase
            };
        }
        return state;
    },
    [ACCTS_ACTIONS.CREATE_CALLBACK_SUCCEEDED](state, { payload }) {
        if (state.data != null && payload.success && payload.data.callback != null) {
            const { callback } = payload.data;
            return {
                ...state,
                data: state.data.map(account => {
                    if (account.id === callback.payableId) {
                        return {
                            ...account,
                            callback
                        };
                    }
                    return account;
                })
            };
        }
        return state;
    },
    [ACCTS_ACTIONS.CANCEL_CALLBACK_SUCCEEDED](state, { payload }) {
        if (state.data != null && payload.cancelled) {
            return {
                ...state,
                data: state.data.map(account => {
                    if (account.callback != null && account.callback.id === payload.id) {
                        return {
                            ...account,
                            callback: null
                        };
                    }
                    return account;
                })
            };
        }
        return state;
    },
    [RESET_MESSAGES](state, { payload }) {
        if (payload === AUTO_ADDED_PAYABLE_MESSAGE_DOMAIN) {
            return {
                ...state,
                autoAddedPayable: false
            };
        }
        return state;
    },
    [ACCTS_ACTIONS.SETTLEMENT_OFFER_UPDATE](state, { payload }) {
        let { data } = state;
        if (data != null) {
            data = data.map(account => {
                if (account.id === payload.payableId) {
                    return {
                        ...account,
                        settlementInfo: payload.info
                    };
                }
                return account;
            });
        }
        return {
            ...state,
            data
        };
    }
});
export default function acctsReducer(previousState, action) {
    let nextState = reducer(previousState, action);
    const callback = callbackReducer(nextState.callback, action);
    if (callback !== nextState.callback) {
        nextState = {
            ...nextState,
            callback
        };
    }
    return nextState;
}



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/accts/acctsReducer.ts